import {debounceTime, delay, map, mergeMap, switchMap, takeUntil, tap} from "rxjs/operators";
import {merge, of} from "rxjs";
import {StartScrollEvent, StopScrollEvent} from "./concat-scroll";

export const init = (cs,
                     sSnap,
                     showAfterScrollFinishedMs = 700) => {


   let header = jQuery('header');

   jQuery("#menu-button, #burger").click(function() {
      jQuery("#burger").toggleClass("open");
      jQuery("#menu-dropdown").toggleClass("close");
   });

   /*cs.scrollStart$.pipe(
      tap( _ => header.addClass('hide') )
   ).subscribe();
   cs.scrollStop$.pipe(
      debounceTime(800),
      tap( _ => header.removeClass('hide')),
      takeUntil(cs.scrollStart$),
      // replay()
   ).subscribe();*/

   jQuery('.menu-item-9838').click( () => {
      sSnap.scrollToSection(2);
      jQuery("#menu-dropdown").addClass("close");
      //sSnap.scrollToSection(2);

   });
   jQuery('.menu-item-9844').click( () => {
      sSnap.scrollToSection(1);
      jQuery("#menu-dropdown").addClass("close");
      //sSnap.scrollToSection(2);

   });
   jQuery('.menu-item-9836').click( () => {
      sSnap.scrollToSection(3);
      jQuery("#menu-dropdown").addClass("close");
   });
   jQuery('.mf, #mobile-logo').click( () => {
      sSnap.scrollToSection(0);
      jQuery("#menu-dropdown").addClass("close");
   });



   merge(cs.scrollStart$, cs.scrollStop$).pipe(
      switchMap((e: StartScrollEvent | StopScrollEvent) => {
         if (e['endTime']) { // check its an endScroll event
            return of(e).pipe(
               delay(showAfterScrollFinishedMs),
               tap(e => {
                  // console.log('header controller', e);
                  if(e['endY'] >= -200 && e['endY'] < 100){
                     header.removeClass('opaque');
                     setTimeout(()=> {

                        header.removeClass('hide');
                     },1)

                  } else /*if(!e['movedDown'])*/{
                     header.addClass('opaque');
                     header.removeClass('hide');
                  }
               })
            )
         } else {
            return of('start').pipe(
               tap(_ => header.addClass('hide'))
            )
         }
      })
   ).subscribe();

};
